/* mff-currency-fix.js
   Makes every custom-coded price on the storefront match the currency the shopper
   selected in the store (Shopify.currency.active), so nothing shows a mismatched,
   hard-coded or unlabelled currency. Four independent fixes:

   (A) Mix & Match "pick your pack" builders (socks + bands) - those prices are
       already computed in the shopper's currency but were hard-labelled " kr".
       Relabel them to the active currency (no conversion needed).

   (B) Consultation page - prices are hard-coded in SEK and the page's own script
       converts them using the visitor's IP location. Re-convert the SEK baseline
       into the shopper's SELECTED currency and keep it applied even if the page's
       IP-based script overwrites it.

   (C) Currency labels (Oct 2026) - most prices are printed with the symbol only
       ("$337.00"), which reads as US dollars to a shopper paying in HKD, SGD, AUD,
       CAD, CNY and so on. Append the ISO code ("$337.00 HKD") on every price
       surface and keep it applied when the theme re-renders (variant change, cart
       drawer, collection filters). Currencies whose symbol is unambiguous in the
       markets that use them (EUR, GBP, SEK, DKK, NOK, and USD inside the US) are
       left exactly as they were. Also repairs the cart-drawer course upsell, which
       printed a euro sign in front of amounts in every currency other than
       SEK / USD / GBP.

   (D) Announcement bar - the International and Europe bars state the free-delivery
       threshold in euros to every shopper. When the shopper is paying in another
       currency, restate it in that currency at Shopify's own rate (the same sum
       the product-page delivery bar uses), so the page shows one currency.

   Safe no-op on pages/currencies where nothing applies. */
(function () {
  var NB = String.fromCharCode(160);     /* non-breaking space */
  var MINUS = String.fromCharCode(8722); /* typographic minus used by the pack builders */
  var EURO = String.fromCharCode(8364);

  function activeCurrency() {
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active;
    } catch (e) {}
    return null;
  }
  function activeCountry() {
    try {
      if (window.Shopify && Shopify.country) return Shopify.country;
    } catch (e) {}
    return null;
  }

  /* ---------- shared: does this currency need its ISO code shown? ---------- */
  var HOME = { EUR: 1, GBP: 1, SEK: 1, DKK: 1, NOK: 1 };
  function needsCode(cur) {
    if (!cur || HOME[cur]) return false;
    if (cur === 'USD' && activeCountry() === 'US') return false;
    return true;
  }
  /* already labelled if the ISO code is present, or a prefixed symbol such as HK$, CA$, A$, S$, NZ$, CN(yen) */
  var PREFIXED = new RegExp('[A-Z]{1,3}[$' + String.fromCharCode(165) + String.fromCharCode(163) + ']');
  function hasCode(txt, cur) {
    return txt.indexOf(cur) !== -1 || PREFIXED.test(txt);
  }
  function withCode(txt, cur) {
    return (needsCode(cur) && !hasCode(txt, cur)) ? txt + NB + cur : txt;
  }
  function rtrim(s) {
    var i = s.length;
    while (i > 0 && (s.charCodeAt(i - 1) <= 32 || s.charCodeAt(i - 1) === 160)) i--;
    return s.slice(0, i);
  }

  function fmtCur(amount, cur, maxFrac) {
    var mf = (maxFrac == null ? 2 : maxFrac);
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, maximumFractionDigits: mf }).format(amount);
    } catch (e) {
      return amount.toFixed(mf) + ' ' + cur;
    }
  }

  /* ---------- (A) Pack builders: relabel " kr" values to the active currency ---------- */
  function svDigits(txt) {
    return txt.split(MINUS).join('-').replace(/[^0-9,-]/g, '');
  }
  function parseSvNum(txt) {
    var n = parseFloat(svDigits(txt).replace(',', '.'));
    return isNaN(n) ? null : n;
  }
  var PACK_IDS = ['mmbs-p3', 'mmbs-p5', 'mmbs-p10', 'mmbs-orig', 'mmbs-dval', 'mmbs-total',
                  'mmbi-p3', 'mmbi-p5', 'mmbi-p10', 'mmbi-orig', 'mmbi-dval', 'mmbi-total'];
  function relabelPack(el, cur) {
    if (!el) return;
    var t = el.textContent;
    if (t === el.__mffTxt) return; /* this is our own output - never re-process it (prevents an observer loop) */
    if (t.indexOf('kr') === -1) return;
    var neg = t.indexOf(MINUS) !== -1 || svDigits(t).charAt(0) === '-';
    var n = parseSvNum(t);
    if (n === null) return;
    var out = (neg ? MINUS : '') + withCode(fmtCur(Math.abs(n), cur), cur);
    el.__mffTxt = out;
    el.textContent = out;
  }
  function bootPack(cur) {
    PACK_IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      relabelPack(el, cur);
      new MutationObserver(function () {
        relabelPack(el, cur);
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- (B) Consultation page: convert SEK baseline -> active currency ---------- */
  var CONS_BASE = { 'price-clarity': 1699, 'price-programme': 4495, 'price-coaching': 2495, 'price-offer': 1199, 'price-offer-original': 1699 };
  function charm(n) { return Math.round(n / 10) * 10 - 1; } /* matches the page's own .9 pricing style */
  function hasConsult() {
    for (var id in CONS_BASE) { if (document.getElementById(id)) return true; }
    return false;
  }
  function bootConsult(cur) {
    if (!hasConsult()) return;
    if (cur === 'SEK') return; /* already displayed correctly in kr */
    fetch('https://open.er-api.com/v6/latest/SEK').then(function (r) { return r.json(); }).then(function (fx) {
      var rate = fx && fx.rates && fx.rates[cur];
      if (!rate) return;
      Object.keys(CONS_BASE).forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        var desired = withCode(fmtCur(charm(CONS_BASE[id] * rate), cur, 0), cur);
        el.textContent = desired;
        new MutationObserver(function () {
          if (el.textContent !== desired) el.textContent = desired; /* override the IP-based converter */
        }).observe(el, { childList: true, characterData: true, subtree: true });
      });
    }).catch(function () {});
  }

  /* ---------- (C) Currency labels on every price surface ---------- */
  var PRICE_SEL = [
    /* custom product page */
    '#mp-price', '.mp-bundle-item-price',
    /* custom collection pages */
    '.mca-card-price', '.mbs-card-price', '.mcb-card-price', '.mcb-card-was', '.mcs-card-price',
    /* homepage + course catalogue */
    '.mfh-hero-card-price', '.mfh-sol-card-price', '.mfh-pc-price', '.mfh-sol-select option',
    '.mc-card-price', '.mc-card-price-orig',
    /* theme-standard prices: product cards, search, recommendations, stock product page */
    '.price__regular', '.price__sale',
    /* cart drawer + cart page */
    '[bss-b2b-item-original-price] .price', '.price[bss-b2b-final-line-price]',
    '.discounts .badge--onsale', '.free-shipping-bar .font-bold', '.totals__subtotal-value', '.totals__subtotal-value span',
    /* free-delivery bar, cross-sell card, bundle builder */
    '.mff-ship b', '.mff-x__price', '[data-product-bundle-total]', '[data-product-bundle-variant-price]'
  ].join(',');
  var UPSELL_SEL = '.mff-up__now,.mff-up__was';
  var UPSELL_OK = { EUR: 1, GBP: 1, SEK: 1, USD: 1 }; /* the upsell script handles these correctly itself */

  /* Append the code to each direct text node that holds an amount, so wrappers
     whose children are labelled separately are left alone. */
  function labelEl(el, cur) {
    if (hasCode(el.textContent || '', cur)) return;
    var kids = el.childNodes, i, n, v;
    for (i = 0; i < kids.length; i++) {
      n = kids[i];
      if (n.nodeType !== 3) continue;
      v = n.nodeValue;
      if (!/[0-9]/.test(v)) continue;
      n.nodeValue = rtrim(v) + NB + cur + v.slice(rtrim(v).length);
    }
  }
  /* The upsell prints a euro sign for any currency it does not know. Swap it for the real code. */
  function fixUpsell(el, cur) {
    var t = el.textContent || '';
    if (t.charAt(0) !== EURO) return;
    el.textContent = rtrim(t.slice(1)) + NB + cur;
  }
  function scan(cur, doLabel, doUpsell) {
    var list, i;
    if (doUpsell) {
      list = document.querySelectorAll(UPSELL_SEL);
      for (i = 0; i < list.length; i++) fixUpsell(list[i], cur);
    }
    if (doLabel) {
      list = document.querySelectorAll(PRICE_SEL + ',' + UPSELL_SEL);
      for (i = 0; i < list.length; i++) labelEl(list[i], cur);
    }
  }
  /* ---------- (D) Announcement bar: euro threshold -> shopper's currency ---------- */
  var EURO_AMOUNT = new RegExp(EURO + ' ?([0-9]+)', 'g');
  function bootAnnouncement(cur) {
    if (cur === 'EUR') return;
    var rate = 0;
    try { rate = parseFloat(Shopify.currency.rate) || 0; } catch (e) {}
    if (!rate) return;
    function conv(m, d) { return cur + ' ' + Math.round(parseInt(d, 10) * rate).toLocaleString('en-US'); }
    function walk(node) {
      var k = node.childNodes, i;
      for (i = 0; i < k.length; i++) {
        if (k[i].nodeType === 3) {
          if (k[i].nodeValue.indexOf(EURO) !== -1) k[i].nodeValue = k[i].nodeValue.replace(EURO_AMOUNT, conv);
        } else if (k[i].nodeType === 1) walk(k[i]);
      }
    }
    var list = document.querySelectorAll('.announcement-text'), j;
    for (j = 0; j < list.length; j++) walk(list[j]);
  }

  function bootLabels(cur) {
    var doLabel = needsCode(cur), doUpsell = !UPSELL_OK[cur];
    if (!doLabel && !doUpsell) return;
    /* the product page swaps in pre-rendered price strings on variant change - label those too */
    if (doLabel && window.mpVariantPrices) {
      try {
        Object.keys(window.mpVariantPrices).forEach(function (k) {
          var s = window.mpVariantPrices[k];
          if (typeof s === 'string') window.mpVariantPrices[k] = withCode(s, cur);
        });
      } catch (e) {}
    }
    var timer = null;
    function run() {
      timer = null;
      try { scan(cur, doLabel, doUpsell); } catch (e) {}
    }
    run();
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function () {
      if (timer === null) timer = setTimeout(run, 50);
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  function boot() {
    var cur = activeCurrency();
    if (!cur) return;
    bootPack(cur);
    bootConsult(cur);
    bootLabels(cur);
    try { bootAnnouncement(cur); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
